import { useCallback, useEffect, useRef, useState } from 'react';
import { contractService } from '../../../services/contracts/ContractService';
import type { FastchipClusterStockBalanceResponse } from '../../../types/dtos';

/**
 * Carrega o balanço de estoque Fastchip uma vez por visita à página de contratos.
 * Recarrega apenas quando `reload()` é chamado explicitamente (ex.: botão Atualizar).
 */
export function useFastchipStockBalance(enabled: boolean) {
  const [balance, setBalance] = useState<FastchipClusterStockBalanceResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const requestIdRef = useRef(0);

  const reload = useCallback(async () => {
    if (!enabled) return;
    const requestId = ++requestIdRef.current;
    try {
      setLoading(true);
      setError(null);
      const data = await contractService.getFastchipClusterStockBalance();
      if (requestId === requestIdRef.current) {
        setBalance(data);
      }
    } catch (err: unknown) {
      if (requestId === requestIdRef.current) {
        const message = err instanceof Error ? err.message : 'Erro ao carregar estoque Fastchip';
        setError(message);
        console.error('useFastchipStockBalance:', err);
      }
    } finally {
      if (requestId === requestIdRef.current) {
        setLoading(false);
      }
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return;
    void reload();
  }, [enabled, reload]);

  return { balance, loading, error, reload };
}
